import { css } from '@emotion/css'
import { colors } from '../../themes'

const styles = {
  wrapper: css({
    boxSizing: 'border-box',
    listStyle: 'none',
    margin: 0,
    padding: 0,
    display: 'flex',
    alignItems: 'stretch',
    height: 50,
    borderBottom: `1px solid ${colors.geyser}`,
    backgroundColor: colors.athensGray,
  }),
}

export default styles
